<script setup lang="ts">
import CloseBold from "@/assets/svg/close.svg";
import { Motion } from "@/utils/motion";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useSystemConfigStoreHook } from "@/store/modules/systemConfig";
import { ElMessage } from "element-plus";
const { t } = useI18n();
// 客服对话框
const serviceDialogVisible = ref(false);
const showServiceDialog = () => {
  serviceDialogVisible.value = true;
};
const copy = async (value: string) => {
  try {
    await navigator.clipboard.writeText(value);
    ElMessage.success(t("common.copySuccess") + " " + value);
  } catch (err) {
    ElMessage.error(t("common.copyFail") || "复制失败");
    console.error("复制失败:", err);
  }
};
defineExpose({ showServiceDialog });
</script>

<template>
  <div v-if="serviceDialogVisible" class="modal-overlay">
    <Motion >
      <div
        class="bg-[#fff] w-[90%] lg:w-[50rem] pb-[2rem] lg:pb-[4rem] relative lg:rounded-[0.63rem] flex flex-col items-center"
      >
        <CloseBold
          @click="serviceDialogVisible = false"
          class="absolute text-[#f3eeee] right-0 lg:text-white lg:right-[20px] lg:top-[20px] text-[3rem] transition duration-300 hover:cursor-pointer hover:-rotate-45 hover:text-primary"
        />

        <div class="relative">
          <div class="text-main-primary mt-[4rem] text-[2.82rem] font-bold">
            {{ t("common.contact") }}
          </div>
          <img
            alt="Future AI"
            :src="useSystemConfigStoreHook().commonConfig.serviceQrUrl"
            class="w-[11.56rem] h-[11.56rem] mt-[6rem] lg:mt-[2rem] z-[9] rounded-[0.4rem]"
          />
        </div>
        <p class="text-[1.1rem] lg:text-[1.125rem] text-[#000]">
          {{ t('footer.col.contact.wechatService')  }}
        </p>
        <!-- 底下联系框 -->
        <div
          class="flex flex-col lg:flex-row mt-[3.25rem] lg:mt-[3rem] justify-center items-center"
        >
          <div
            v-if="useSystemConfigStoreHook().commonConfig.contactEmail"
            class="w-[20rem] border-[#D8D8D8] mb-[1rem] flex justify-center lg:border-r-[0.5px]"
          >
            <div class="flex flex-col justify-start">
              <div
                class="text-[#000] mb-[0.5rem] text-[1.29rem] font-[OPPOSansM] font-[700] text-start"
              >
                {{ t('footer.col.contact.email') }}
              </div>
              <div class="text-[1.29rem] text-[#000]">
                {{ useSystemConfigStoreHook().commonConfig.contactEmail }}
                <el-link
                  class="!text-[0.94rem] text-primary ml-[1.5rem]"
                  :underline="false"
                  type="primary"
                  @click="
                    copy(
                      useSystemConfigStoreHook().commonConfig.contactEmail
                    )
                  "
                >
                  {{ t("common.copy") }}
                </el-link>
              </div>
            </div>
          </div>
          <div
            v-if="useSystemConfigStoreHook().commonConfig.contactPhone"
            class="w-[15.44rem] lg:border-r-[0.5px] border-[#D8D8D8] mb-[1rem] flex justify-center"
          >
            <div class="flex flex-col justify-start">
              <div
                class="text-[#000] mb-[0.5rem] text-[1.29rem] font-[700] text-start"
              >
                {{ t('footer.col.contact.phone')  }}
              </div>
              <div class="text-[1.29rem] text-[#000] flex items-center">
                {{ useSystemConfigStoreHook().commonConfig.contactPhone }}
                <el-link
                  class="!text-[0.94rem] text-primary ml-[1.5rem]"
                  :underline="false"
                  type="primary"
                  @click="
                    copy(
                      useSystemConfigStoreHook().commonConfig.contactPhone
                    ) 
                  "
                >
                  {{ t("common.copy") }}
                </el-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Motion>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0; /* 等同于 top:0; right:0; bottom:0; left:0 */
  z-index: 99; /* 保证浮在最上层 */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4); /* 可选遮罩背景 */
}
</style>
